import React from 'react';
import { Star, DownloadSimple, Lightning, Trash } from '@phosphor-icons/react';

const fmtDD = (iso) => (iso ? iso.slice(0, 10).split('-').reverse().join('/') : '');

/** Favoriete rondes: een vaste klantenselectie die u elke maand opnieuw kan rijden. */
export const FavoRondes = ({ favos = [], bezig = '', datum, kanBewaren, onBewaar, onLaden, onRijden, onWis }) => (
  <div className="bg-white border border-gray-200 p-3 sm:p-4 mb-3" data-testid="favo-rondes">
    <div className="flex items-center justify-between gap-2 flex-wrap">
      <div className="inline-flex items-center gap-1.5 text-sm font-bold text-gray-900"><Star size={16} weight="fill" className="text-amber-500" /> Favoriete rondes</div>
      <button type="button" disabled={!kanBewaren || bezig === 'favo-bewaar'} onClick={onBewaar}
        className="h-9 px-3 text-xs font-bold border border-amber-400 text-amber-700 bg-amber-50 inline-flex items-center gap-1.5 disabled:opacity-40"
        title={kanBewaren ? 'De huidige klantenselectie als vaste ronde bewaren' : 'Kies eerst klanten'} data-testid="favo-bewaar">
        <Star size={14} weight="fill" /> {bezig === 'favo-bewaar' ? 'Bewaren…' : 'Huidige selectie bewaren'}
      </button>
    </div>
    {!favos.length
      ? <p className="text-[11px] text-gray-500 mt-1.5">Nog geen favorieten. Kies klanten, bewaar ze als ronde en rijd ze elke maand opnieuw met één tik.</p>
      : (
        <div className="mt-2 border border-gray-200 divide-y divide-gray-100" data-testid="favo-lijst">
          {favos.map(f => (
            <div key={f.id} className="p-2.5" data-testid={`favo-${f.id}`}>
              <div className="flex items-baseline justify-between gap-2">
                <span className="font-semibold text-sm truncate">{f.naam}</span>
                <span className="text-[11px] text-gray-500 shrink-0">{f.aantal_klanten} klanten</span>
              </div>
              <div className="text-[11px] text-gray-500 truncate">
                {f.verkoper_naam ? `👤 ${f.verkoper_naam} · ` : ''}max {f.max_per_dag}/dag · {f.bezoektijd_min} min/bezoek
                {f.laatst_gebruikt ? ` · laatst gereden ${fmtDD(f.laatst_gebruikt)}${f.aantal_keer ? ` (${f.aantal_keer}×)` : ''}` : ' · nog niet gereden'}
              </div>
              <div className="grid grid-cols-3 gap-1.5 mt-2 text-xs font-semibold">
                <button type="button" disabled={!!bezig} onClick={() => onLaden(f)} className="h-10 border border-gray-300 bg-white inline-flex items-center justify-center gap-1 disabled:opacity-40" data-testid={`favo-laden-${f.id}`}><DownloadSimple size={14} /> Laden</button>
                <button type="button" disabled={!!bezig} onClick={() => onRijden(f)} className="h-10 border border-[#002FA7] text-[#002FA7] bg-white inline-flex items-center justify-center gap-1 disabled:opacity-40" title={`Direct plannen en opslaan op ${fmtDD(datum)}`} data-testid={`favo-rijden-${f.id}`}><Lightning size={14} weight="fill" /> {bezig === `favo-rijden-${f.id}` ? 'Bezig…' : 'Rijd opnieuw'}</button>
                <button type="button" disabled={!!bezig} onClick={() => onWis(f)} className="h-10 border border-red-200 text-red-600 bg-white inline-flex items-center justify-center gap-1 disabled:opacity-40" data-testid={`favo-wis-${f.id}`}><Trash size={14} /> Wis</button>
              </div>
            </div>
          ))}
        </div>
      )}
  </div>
);

export default FavoRondes;
